export default {
  sharedUi: {
    common: {
      loading: "Loading...",
      clear: "Clear",
      close: "Close",
      open: "Open",
      search: "Search",
      moreActions: "More actions",
      ok: "Ok",
      error: "Error",
      errorOccurred: "An error occurred",
      logOut: "Log out",
      yes: "Yes",
      no: "No",
      cancel: "Cancel",
      continue: "Continue",
      back: "Back",
      hide: "Hide",
      showAll: "Show all",
      printIcon: "Print icon",
    },
    filters: {
      noResults: "No results found",
      noOptions: "No options",
      select: "Select",
      all: "All",
      applyFilter: "Apply filter",
      reset: "Reset",
      removeItem: "Remove {{label}}",
      selectEllipsis: "Select…",
      noMatches: "No matches",
      clearSelection: "Clear selection",
    },
    datepicker: {
      today: "Today",
      calendarIcon: "Calendar icon",
    },
    onboarding: {
      status: {
        completed: "Completed",
        inReview: "Under review",
        actionRequired: "Action required",
        notRequired: "Not required",
        optional: "Optional",
      },
      markerStatus: {
        available: "available",
        completed: "completed",
        in_review: "in review",
        action_required: "action required",
        not_required: "not required",
        optional: "optional",
        pending: "pending",
      },
      markerChecked: "{{status}} checked",
      stepsAriaLabel: "Onboarding steps",
      whatToComplete: "What do I need to complete?",
      stepsCompleted: "{{completed}} of {{total}} steps completed",
      requirements: "Requirements",
      pleaseNote: "Please note",
      minutes: "{{count}} min",
      companyProfile: {
        title: "Company profile",
        description: "Add your company information used across L'Authorize.",
        completeProfile: "Complete profile",
        learningTitle: "How to complete your profile",
        requirements: {
          useEnglish: "Use English for all fields",
          fullAddress: "Complete your full address",
          vatNumber: "Add your VAT number",
          verifyContacts: "Verify your company email and phone number",
          saveRequired: "Save all required fields",
        },
        notes: {
          nameChange: "Company name changes may require document verification",
          matchRegistration: "Information must match official business registration documents",
        },
      },
      billingDetails: {
        title: "Billing details",
        description:
          "Complete your billing details so we can create your proforma invoice and set up your subscription.",
        completeBilling: "Complete billing details",
        whyNeededTitle: "Why this is needed",
        goodToKnowTitle: "Good to know",
        missingInfoNote: "Missing billing information may delay invoice creation and subscription setup.",
        requirements: {
          requiredFields: "Complete all required billing fields",
          accurateInfo: "Make sure the information is accurate and up to date",
          saveDetails: "Save your billing details",
        },
        whyNeeded: {
          proforma: "We use these details to create your proforma invoice",
          subscription: "Your subscription can be set up once the required billing information is available",
        },
        goodToKnow: {
          updateLater: "You can update your billing information later",
        },
      },
    },
    eprModals: {
      processingPaymentTitle: "Processing Payment",
      processingPaymentText: "Processing payment and connecting subscription or add-on...",
      pleaseWaitAttempt: "Please wait... (Attempt {{attempt}}/{{total}})",
      underDevelopmentTitle: "Declaration Type Under Development",
      underDevelopmentDescription:
        "This type of EPR declaration is currently under development. Please try another declaration type or contact support for more information.",
      noRepresentative: "Please contact support. No tax representation addon",
    },
    periods: {
      biAnnual1: "bi-annual (Jan-Jun)",
      biAnnual2: "bi-annual (Jul-Dec)",
      biMonthly1: "bi-monthly (Jan-Feb)",
      biMonthly2: "bi-monthly (Mar-Apr)",
      biMonthly3: "bi-monthly (May-Jun)",
      biMonthly4: "bi-monthly (Jul-Aug)",
      biMonthly5: "bi-monthly (Sep-Oct)",
      biMonthly6: "bi-monthly (Nov-Dec)",
      period1: "1 period (March - May)",
      period2: "2 period (June - August)",
      period3: "3 period (September - November)",
      period4: "4 period (December - February)",
    },
    periodicity: {
      year: "Year",
      quarter: "Quarter",
      month: "Month",
      biAnnual: "Bi-Annual",
    },
    epr: {
      subcategoryN: "Subcategory {{n}}",
    },
    sso: {
      testComplete: "Finished testing your configuration, you can now go back to the original tab",
    },
    banner: {
      viewDetails: "View details",
      closeBanner: "Close banner",
    },
    authError: {
      title: "Sign-in error",
      invitationNotFound: "Please sign in with the Google account for the email this invitation was sent to.",
    },
    pagination: {
      range: "{{from}} - {{to}} of {{total}}",
    },
    customerValidation: {
      title: "Customer Validation Failed",
      defaultMessage: "Customer validation failed.",
    },
    modal: {
      hidePassword: "Hide password",
      showPassword: "Show password",
    },
    paymentStatus: {
      success: "Payment success",
      error: "Payment error",
      warning: "Payment warning",
      generic: "Payment {{status}}",
    },
    tabs: {
      tabs: "Tabs",
      moreTabs: "More tabs",
      countAria: "{{label}} count {{count}}",
      filter: "Filter",
      moreOptions: "More options",
    },
    twoFactor: {
      title: "Two-step authentication",
      subtitle:
        "Enabling this will provide an extra layer of security for your account. When logging in, we will ask for a special authentication code from your device",
      enabling: "Enabling...",
      enable: "Enable Two-factor authentication",
    },
    subscriptionModal: {
      columns: {
        month: "Month",
        period: "Period",
        yourPlan: "Your plan",
        inPlan: "In plan",
        needed: "Needed",
        covered: "Covered",
        needTotal: "Need Total",
        gap: "Gap",
        quantity: "Quantity",
        price: "Price",
      },
      monthN: "Month {{n}}",
      periodN: "Period {{n}}",
      standard: "Standard",
      additionalInvoices: "Additional invoices",
      addon: "Addon",
      eprReport: "EPR Report",
      subscription: "Subscription",
      subtotal: "Subtotal",
      addons: "Add-ons",
      additionalTransactions: "Additional transactions",
      additionalRevenue: "Additional revenue",
      eprAdditionalReports: "EPR Additional Reports",
      total: "Total",
      purchaseAndContinue: "Purchase and continue",
      actions: {
        salesTaxReturn: "file your Sales Tax return",
        eprReport: "file your EPR report",
        eDocument: "send your e-document",
        vatReturn: "file your VAT return",
      },
      warning: {
        subscriptionAndAddonsTitle: "You don't have enough subscription and add-ons",
        subscriptionAndAddonsSubtitle:
          "To {{action}}, you need subscription and add-ons. We've added the missing ones so your filing is complete",
        subscriptionTitle: "You don't have enough subscription",
        subscriptionSubtitle:
          "To {{action}}, you need subscription. We've added the missing ones so your filing is complete",
        addonsTitle: "You don't have enough add-ons",
        addonsSubtitle: "To {{action}}, you need add-ons. We've added the missing ones so your filing is complete",
        fallbackTitle: "You don't have enough addons (subscription and addons) to {{action}}",
      },
      alerts: {
        noData: "No subscription data available. Please try again.",
        stripeNotInitialized: "Stripe is not initialized. Please wait a moment and try again.",
        paymentError: "Payment error: {{message}}",
        redirectFailed: "Payment redirect failed. Please try again.",
        stripeInitFailed: "Stripe initialization failed. Please try again.",
        purchaseSuccessful: "Purchase successful!",
        networkError: "Network error occurred. Please check your connection and try again.",
      },
    },
    userGuide: {
      title: "User Guide",
      intro: "Here are some tips and setup tasks to help you get started",
      tasksLeft: "{{tasks}} tasks left (About {{minutes}} minutes)",
      step1Text:
        "Use the English language to fill in your address and the name of the company. When you will fill in your VAT returns all info from here will go straight to VAT returns translated to a respective language.",
      goToProfile: "Go to profile",
      step2Text:
        "If you sell at Amazon or Shopify or another Marketplace you can connect your store to your Marketplace account right away. If you have a custom website you will have a token to connect as you create a store. For each store, you can set up a domestic country. Domestic country means that for this country VAT is not calculated by our software.",
      createStore: "Create store",
      step3TextBeforeLink: "This section is very important you can",
      watchVideoTutorials: "watch video tutorials",
      step3TextAfterLink:
        "or ask the onboarding team for support. Fill in at least one VAT number or sales tax permit to be able to file tax returns. Bear in mind that you need all your numbers filled in and activated before you upload any transactions. It influences tax calculations significantly.",
      fillTaxSettings: "Fill tax settings",
      skip: "Skip",
      step4Title: "There are four options to upload.",
      step4Marketplace:
        "Integration with a marketplace - go to the transaction section and choose the button “upload transactions”. You can find guides for integration with Amazon, EBay or Shopify",
      step4Manual: "Manual uploading from excel spreadsheets",
      step4Api: "API integration - normally you don’t need to upload transactions – they are uploaded in real time",
      step4Plugins: "Uploading via plugins for Magento, Woo-commerce",
      uploadTransactions: "Upload transactions",
      noDescription: "no description",
      completedAlt: "completed",
      showPreviousTasks: "Show previous tasks",
      completedGuideAlt: "completed user guide",
      nextSteps: "Customers who completed these tasks do this next",
      createVatReturn: "Create VAT Return",
      furtherHelp:
        "If you need any further help, our help center has a lot of video tutorials & a personal manager who will be happy to help you out",
      openHelpCenter: "Open Help Center",
    },
    validation: {
      invalidEmail: "Invalid email address",
      invalidPhone: "Invalid phone number",
      required: "Required",
      minLength: "Must be at least {{count}} characters",
      maxLength: "Must be no more than {{count}} characters",
      integer: "Must be an integer",
      oneOf: "Must be one of: {{values}}",
      noMatch: "Do not match",
    },
    teamRoles: {
      taxAgentOwner: "Tax agent owner",
      taxAgentUser: "Tax agent user",
      roleN: "Role {{id}}",
    },
  },
};
